import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavbarPocessoService } from './navbar-pocesso.service';
import { SharedService } from '../../common/shared.service';
import { WebsocketService } from '../../common/websocket.service';

const keyProcessoId = 'KEY_STORE_PROCESSO_FOLPAG';

@Component({
  selector: 'app-navbar-processo',
  templateUrl: './navbar-processo.component.html',
  styleUrls: ['./navbar-processo.component.css']
})
export class NavbarProcessoComponent implements OnInit, OnDestroy {

  processos: any[] = [];
  ids: any[] = [];
  minimized: boolean = true;
  notificador: boolean = false;
  classNotificador = 'fadeInUp';
  msg: string = 'Um processo foi iniciado.';

  private subscriptions = new Subscription();

  constructor(
    private barNavService: NavbarPocessoService,
    private shared: SharedService,
    private ws: WebsocketService
  ) {
  }

  ngOnInit() {
    this.ids = JSON.parse(sessionStorage.getItem(keyProcessoId) || '[]');
    this.subscriptions.add(
      this.barNavService.notificador.subscribe((id: number) => {
        if (!this.contemId(id)) {
          this.ids.push(id);
          sessionStorage.setItem(keyProcessoId, JSON.stringify(this.ids));
        }
      })
    );
    // Usa o WebsocketService (com reconexão) em vez de um webSocket isolado
    // cujo handler de erro recriava a conexão sem re-inscrever — a barra parava até F5.
    this.subscriptions.add(
      this.ws.listen().subscribe(msg => this.onMensagemWs(msg))
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  toggle() {
    this.minimized = !this.minimized;
  }

  notificar(msg: string) {
    this.msg = msg;
    if (this.notificador === false) {
      this.notificador = true;
      setTimeout(() => {
        this.classNotificador = 'fadeOutDown';
        setTimeout(() => {
          this.notificador = false;
          this.classNotificador = 'fadeInUp';
        }, 1500);
      }, 3000);
    }
  }

  private onMensagemWs(msg: any) {
    if (!msg || !msg.payload) {
      return;
    }

    const entidadeId = this.shared && this.shared.usuario && this.shared.usuario.entidade
      ? this.shared.usuario.entidade.id
      : null;
    if (entidadeId == null || Number(entidadeId) !== Number(msg.payload.entidade)) {
      return;
    }

    const payload = msg.payload;
    const global: boolean = !!msg.global;

    if (!this.contemId(payload.id) && !global) {
      return;
    }

    if (this.processos.some(status => status.id === payload.id)) {
      this.processos = this.processos.map(s => s.id === payload.id ? payload : s);
    } else {
      if (!this.contemId(payload.id)) {
        this.ids.push(payload.id);
      }
      this.processos.push(payload);
      this.notificar('Um processo iniciado.');
    }

    const concluidos = this.processos.filter(s => this.estaConcluido(s));
    if (concluidos.length) {
      this.notificar('Um processo concluído.');
    }

    this.processos = this.processos.filter(s => !this.estaConcluido(s));
    this.ids = this.processos.map(p => p.id);
    sessionStorage.setItem(keyProcessoId, JSON.stringify(this.ids));
  }

  private contemId(id: any): boolean {
    return this.ids.some(stored => Number(stored) === Number(id));
  }

  /** Evita remover processo com totalRegistro ainda 0 (estado inicial inconsistente). */
  private estaConcluido(status: any): boolean {
    const total = Number(status && status.totalRegistro);
    const atual = Number(status && status.posicaoAtual);
    return total > 0 && atual >= total;
  }

}
